import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  right?: ReactNode
}

export function FilterBar({ children, right }: Props) {
  return (
    <div className="filter-bar">
      {children}
      <div style={{ flex: 1 }} />
      {right}
    </div>
  )
}
